module.exports = "<ng-template #navbarHeaderRightActionsTemplate>\n    <ng-content></ng-content>\n</ng-template>"